import UpcomingSessionsGrid from "@/components/scheduling/UpcomingSessionsGrid";

export default function InstructorSessions() {
  return (
    <div className="container mx-auto px-4 py-8">
      <header className="mb-6">
        <h1 className="text-3xl font-bold">Sessions</h1>
        <p className="text-muted-foreground">Upcoming tutoring sessions across your students.</p>
      </header>
      <UpcomingSessionsGrid />
    </div>
  );
}
